module.exports = __webpack_public_path__ + "28900c135e8dbe80103930247fef0c65.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1145
// module chunks = 0